import { useEffect } from 'react';
import type { ReactNode } from 'react';
import { ensureStyles } from '@braidlabs/console';

/**
 * Theme setup for both halves of the console.
 *
 * **There is one theme.** Broadsheet is a paper ground with two process inks and no dark ramp,
 * and the handoff's rule is not to invent values — so adopting it meant dropping the dark theme
 * and the toggle rather than making up nine colours the designer never drew. A light-only
 * operator console is a smaller lie than a dark theme we authored ourselves.
 *
 * `data-theme` is still stamped on `<html>`, because the OSS components read exactly that
 * attribute and default to following the OS. Without it, `TopologyGraph` would go dark inside a
 * dark OS while everything around it stayed on paper.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'light');
    document.documentElement.style.colorScheme = 'light';
  }, []);

  // The OSS stylesheet is injected once, on demand. Doing it here rather than in a page component
  // means it is present before the first OSS component paints.
  useEffect(() => { ensureStyles(); }, []);

  return <>{children}</>;
}
